module.exports = __webpack_public_path__ + "static/media/Rebis.30f7ba0c.svg";